<div class="edit-container" [class.embedded]="embedded">
  <div class="content">
    <form [formGroup]="deviceForm" (ngSubmit)="onSubmit()" class="body">
      <div class="first-section">
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="assetType">{{
              "DEVICESETUP_ASSETTYPE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select (change)="onAssetTypeSelected($event)" id="assetType" formControlName="assetType">
                <option *ngFor="let item of assetTypes" [value]="item.value">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class="form-validation">
              <div *ngIf="formErrorsExists('assetType')" class="validation-error">
                {{ "DEVICESETUP_ASSETTYPE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
              </div>
              <div *ngIf="deviceForm.get('assetType')?.untouched && deviceForm.get('assetType')?.invalid"
                class="validation-instruction">
                {{ "DEVICESETUP_ASSETTYPEDESC" | translate }}
              </div>
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="parent">{{
              "DEVICESETUP_PARENT" | translate
              }}</label>
          </div>
          <div class="form-input ">
            <app-parent-meter-dropdown-search [disabled]="!selectedAssetType" [fetchItems]="fetchParents"
              [selected]="selectedParent" [placeholder]="'SEARCHBY_METERNUMBER_OR_ASSETNAME'"
              (selectedItem)="onParentSelected($event)" />
            <div *ngIf="formErrorsExists('parent')" class="validation-error">
              {{ "DEVICESETUP_PARENT" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('parent')?.untouched && deviceForm.get('parent')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_AREADESC" | translate }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="serviceLatitude">{{
              "DEVICESETUP_SERVICELATITUDE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="serviceLatitude" formControlName="serviceLatitude" min="-90" max="90" step="0.000001"
                type="number" />
            </div>
            <div *ngIf="deviceForm.get('serviceLatitude')?.untouched && deviceForm.get('serviceLatitude')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_SERVICELATITUDEDESC" | translate }}
            </div>
            <div *ngIf="formErrorsExists('serviceLatitude')" class="validation-error">
              {{ "DEVICESETUP_SERVICELATITUDEERROR" | translate }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="serviceLongitude">{{
              "DEVICESETUP_SERVICELONGITUDE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="serviceLongitude" formControlName="serviceLongitude" type="number" min="-180" max="180"
                step="0.000001" />
            </div>
            <div *ngIf="deviceForm.get('serviceLongitude')?.untouched && deviceForm.get('serviceLongitude')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_SERVICELONGITUDEDESC" | translate }}
            </div>
            <div *ngIf="formErrorsExists('serviceLongitude')" class="validation-error">
              {{ "DEVICESETUP_SERVICELONGITUDEERROR" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="serviceName">{{
              "DEVICESETUP_SERVICENAME" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="serviceName" formControlName="serviceName" type="text" />
            </div>
            <div *ngIf="formErrorsExists('serviceName')" class="validation-error">
              {{ "DEVICESETUP_SERVICENAME" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('serviceName')?.untouched && deviceForm.get('serviceName')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_SERVICENAMEDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="horizontal-line"></div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="region">{{ "DEVICESETUP_REGION" | translate }}:</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select id="region" formControlName="region" (change)="getAreasByRegion($event)">
                <option *ngFor="let item of regions" [value]="item.value">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div *ngIf="formErrorsExists('region')" class="validation-error">
              {{ "DEVICESETUP_REGION" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('region')?.untouched && deviceForm.get('region')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_REGIONDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="area">{{ "DEVICESETUP_AREA" | translate }}:</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select id="area" formControlName="area" [attr.disabled]="areas.length === 0 ? '' : null">
                <option *ngFor="let item of areas" [value]="item.value">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div *ngIf="formErrorsExists('area')" class="validation-error">
              {{ "DEVICESETUP_AREA" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('area')?.untouched && deviceForm.get('area')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_AREADESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="address">{{
              "DEVICESETUP_DEVICEADDRESS" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="address" formControlName="address" type="text" />
            </div>
            <div *ngIf="formErrorsExists('address')" class="validation-error">
              {{ "DEVICESETUP_DEVICEADDRESS" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('address')?.untouched && deviceForm.get('address')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_DEVICEADDRESSDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="horizontal-line"></div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="serviceNumber">{{
              "DEVICESETUP_SERVICENUMBER" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="serviceNumber" formControlName="serviceNumber" type="text" />
            </div>
            <div *ngIf="!deviceForm.get('serviceNumber')?.value" class="validation-instruction">
              {{ "DEVICESETUP_SERVICENUMBERDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="serviceType">{{
              "DEVICESETUP_SERVICETYPE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select id="serviceType" formControlName="serviceType">
                <option *ngFor="let item of serviceTypes" [value]="item.value">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div *ngIf="!deviceForm.get('serviceType')?.value" class="validation-instruction">
              {{ "DEVICESETUP_SERVICETYPEDESC" | translate }}.
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterNumber">{{
              "DEVICESETUP_METERNO" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="meterNumber" formControlName="meterNumber" type="text" />
            </div>
            <div *ngIf="formErrorsExists('meterNumber')" class="validation-error">
              {{ "DEVICESETUP_METERNO" | translate }}{{ "DEVICESETUP_ISREQUIRED" | translate }}
            </div>
            <div *ngIf="!deviceForm.get('meterNumber')?.value" class="validation-instruction">
              {{ "DEVICESETUP_METERNODESC" | translate }}
            </div>
            <div *ngIf="deviceForm.get('meterNumber')?.errors?.['pattern']" class="validation-error">
              {{ "METERNUMBER_ERROR" | translate }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label">{{
              "DEVICESETUP_METERMAKE" | translate
              }}</label>
          </div>
          <div class="form-label-div">
            <span class="pe-4 pt-3 pb-3 item-info">{{device.meterMakeName}}</span>
          </div>
        </div>

        <div *ngIf="!device.enableMeterModelEdit" class="form-item">
          <div class="form-label-div">
            <label class="form-label">{{
              "DEVICESETUP_METERMODEL" | translate
              }}</label>
          </div>
          <div class="form-label-div">
            <span class="pe-4 pt-3 pb-3 item-info">{{device.meterModelName}}</span>
          </div>
        </div>

        <div *ngIf="device.enableMeterModelEdit" class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterModel">{{
              "DEVICESETUP_METERMODEL" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select id="meterModel" name="meterModel" formControlName="meterModel" required (change)="getMeterModel()"
                [attr.disabled]="device.meterMake == undefined ? '' : null">
                <option value="" disabled selected hidden></option>
                <option *ngFor="let item of meterModels" [value]="item.value">
                  {{ item.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterType">{{
              "DEVICESETUP_METERTYPE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select id="meterType" formControlName="meterType">
                <option *ngFor="let item of meterTypeDictionary" [value]="item">
                  {{ item }}
                </option>
              </select>
            </div>
            <div *ngIf="formErrorsExists('meterType')" class="validation-error">
              {{ "DEVICESETUP_METERTYPE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('meterType')?.untouched && deviceForm.get('meterType')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_METERTYPEDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterPhase">{{
              "DEVICESETUP_METERPHASE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="meterPhase" formControlName="meterPhase" type="text" />
            </div>
            <div class="validation-instruction">
              {{ "DEVICESETUP_METERPHASEDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="horizontal-line"></div>

        <div class="section-title-segment">
          <h5 class="section-title">{{ "CT_RATIO_TITLE" | translate }}</h5>
          <h6 class="section-subtitle">{{ "CT_RATIO_SUBTITLE" | translate }}</h6>
        </div>

        <div class="horizontal-line"></div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="ctNumerator">{{
              "DEVICESETUP_CT_NUMERATOR" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="ctNumerator" formControlName="currentTransformerRatioNumerator" type="number" step="1" />
            </div>
            <ng-container *ngIf="formErrorsExists('currentTransformerRatioNumerator')">
              <div class="validation-error">
                <ng-container *ngIf="deviceForm.get('currentTransformerRatioNumerator')?.errors?.['required']">
                  {{ "DEVICESETUP_CT_NUMERATOR_REQUIRED_ERROR" | translate }}
                </ng-container>
                <ng-container *ngIf="deviceForm.get('currentTransformerRatioNumerator')?.errors?.['min']">
                  {{ "DEVICESETUP_CT_NUMERATOR_ERROR" | translate }}
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="ctDenominator">{{
              "DEVICESETUP_CT_DENOMINATOR" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="ctDenominator" formControlName="currentTransformerRatioDenominator" type="number" step="1" />
            </div>
            <ng-container *ngIf="formErrorsExists('currentTransformerRatioDenominator')">
              <div class="validation-error">
                <ng-container *ngIf="deviceForm.get('currentTransformerRatioDenominator')?.errors?.['required']">
                  {{ "DEVICESETUP_CT_DENOMINATOR_REQUIRED_ERROR" | translate }}
                </ng-container>
                <ng-container *ngIf="deviceForm.get('currentTransformerRatioDenominator')?.errors?.['min']">
                  {{ "DEVICESETUP_CT_DENOMINATOR_ERROR" | translate }}
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="horizontal-line"></div>

        <div class="section-title-segment">
          <h5 class="section-title">{{ "VT_RATIO_TITLE" | translate }}</h5>
          <h6 class="section-subtitle">{{ "VT_RATIO_SUBTITLE" | translate }}</h6>
        </div>

        <div class="horizontal-line"></div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="vtNumerator">{{
              "DEVICESETUP_VT_NUMERATOR" | translate
              }}</label>
          </div>

          <div class="form-input">
            <div class="form-input-div">
              <input id="vtNumerator" formControlName="voltageTransformerRatioNumerator" type="number" step="1" />
            </div>
            <ng-container *ngIf="formErrorsExists('voltageTransformerRatioNumerator')">
              <div class="validation-error">
                <ng-container *ngIf="deviceForm.get('voltageTransformerRatioNumerator')?.errors?.['required']">
                  {{ "DEVICESETUP_VT_NUMERATOR_REQUIRED_ERROR" | translate }}
                </ng-container>
                <ng-container *ngIf="deviceForm.get('voltageTransformerRatioNumerator')?.errors?.['min']">
                  {{ "DEVICESETUP_VT_NUMERATOR_ERROR" | translate }}
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="vtDenominator">{{
              "DEVICESETUP_VT_DENOMINATOR" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="vtDenominator" formControlName="voltageTransformerRatioDenominator" type="number" step="1" />
            </div>
            <ng-container *ngIf="formErrorsExists('voltageTransformerRatioDenominator')">
              <div class="validation-error">
                <ng-container *ngIf="deviceForm.get('voltageTransformerRatioDenominator')?.errors?.['required']">
                  {{ "DEVICESETUP_VT_DENOMINATOR_REQUIRED_ERROR" | translate }}
                </ng-container>
                <ng-container *ngIf="deviceForm.get('voltageTransformerRatioDenominator')?.errors?.['min']">
                  {{ "DEVICESETUP_VT_DENOMINATOR_ERROR" | translate }}
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="horizontal-line"></div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="gsmProvider">{{
              "DEVICESETUP_GSMPROVIDER" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select id="gsmProvider" formControlName="gsmProvider">
                <option *ngFor="let item of gsmProviderDictionary" [value]="item">
                  {{ item }}
                </option>
              </select>
            </div>
            <div *ngIf="formErrorsExists('gsmProvider')" class="validation-error">
              {{ "DEVICESETUP_GSMPROVIDER" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('gsmProvider')?.untouched && deviceForm.get('gsmProvider')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_GSMPROVIDERDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="cellularSimSerialNumber">{{
              "DEVICESETUP_CELLULARSIMSN" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="cellularSimSerialNumber" formControlName="cellularSimSerialNumber"
                [attr.disabled]="!deviceForm.get('gsmProvider')?.value ? '' : null" type="text" (change)="getIpFromGsmProvider()" />
            </div>
            <div *ngIf="formErrorsExists('cellularSimSerialNumber')" class="validation-error">
              {{ "DEVICESETUP_CELLULARSIMSN" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('gsmProvider')?.invalid" class="validation-error">
              {{ "DEVICESETUP_GSMFIRST" | translate }}
            </div>
            <div
              *ngIf="deviceForm.get('cellularSimSerialNumber')?.untouched && deviceForm.get('cellularSimSerialNumber')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_CELLULARSIMSNDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterIp">{{
              "DEVICESETUP_METERIP" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="meterIp" formControlName="meterIp" type="text" />
            </div>
            <div *ngIf="formErrorsExists('meterIp')" class="validation-error">
              {{ "DEVICES_INVALID" | translate }} {{ "DEVICESETUP_METERIP" | translate }} {{ "DEVICESETUP_DEVICEADDRESS"
              | translate }} format.
            </div>
            <div *ngIf="deviceForm.get('meterIp')?.untouched && deviceForm.get('meterIp')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_METERIPDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterPort">{{
              "DEVICESETUP_METERPORT" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="meterPort" formControlName="meterPort" type="number" />
            </div>
            <div *ngIf="formErrorsExists('meterPort')" class="validation-error">
              {{ "INTEGER_ERROR" | translate }}
            </div>
            <div *ngIf="deviceForm.get('meterPort')?.untouched && deviceForm.get('meterPort')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_METERPORTDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterInterface">{{
              "DEVICESETUP_INTERFACE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="meterInterface" formControlName="meterInterface" type="text" />
            </div>
            <div class="validation-instruction">
              {{ "DEVICESETUP_INTERFACEINFODESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="authenticationType">{{
              "DEVICESETUP_AUTHTYPE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="authenticationType" formControlName="autentificationType" type="text" />
            </div>
            <div class="validation-instruction">
              {{ "DEVICESETUP_AUTHTYPEINFODESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="dataCollectionInterval">{{
              "DEVICESETUP_DATACOLLECTIONINTERVALS" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select id="dataCollectionInterval" formControlName="dataCollectionInterval">
                <option *ngFor="let interval of intervals" [value]="interval.value">
                  {{formatInterval(interval.value)}}
                </option>
              </select>
            </div>
            <div *ngIf="formErrorsExists('dataCollectionInterval')" class="validation-error">
              {{ "DEVICESETUP_DATACOLLECTIONINTERVALS" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div
              *ngIf="deviceForm.get('dataCollectionInterval')?.untouched && deviceForm.get('dataCollectionInterval')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_DATACOLLECTIONINTERVALSDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="clockOffset">{{
              "CLOCK_OFFSET" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="clockOffset" formControlName="clockOffset" type="number" />
            </div>
            <div *ngIf="deviceForm.get('clockOffset')?.untouched && deviceForm.get('clockOffset')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_CLOCKOFFSET" | translate }}
            </div>
            <div *ngIf="deviceForm.get('clockOffset')?.touched && deviceForm.get('clockOffset')?.invalid"
              class="validation-error">
              {{ "DEVICESETUP_CLOCKOFFSETERROR" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterTimeZone">{{
              "DEVICESETUP_TIMEZONE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <select id="meterTimeZone" formControlName="meterTimeZone">
                <option *ngFor="let zone of timezones" [value]="zone.value">
                  {{ zone.name }}
                </option>
              </select>
            </div>
            <div *ngIf="formErrorsExists('meterTimeZone')" class="validation-error">
              {{ "DEVICESETUP_TIMEZONE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div *ngIf="deviceForm.get('meterTimeZone')?.untouched && deviceForm.get('meterTimeZone')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_TIMEZONEDESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="clientAddress">{{
              "DEVICESETUP_CLIENTADDRESS" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="clientAddress" formControlName="clientAddress" type="text" />
            </div>
            <div class="validation-instruction">
              {{ "DEVICESETUP_CLIENTADDRESSINFODESC" | translate }}
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterInstallationDate">{{
              "DEVICESETUP_INSTALLATIONDATE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div" (click)="toggleDatepicker(); $event.stopPropagation()">
              <input type="hidden" formControlName="meterInstallationDate" />
              <input id="meterInstallationDate" type="text" [value]="formattedMeterInstallationDate" readonly />
            </div>
            @if (isDatepickerShown) {
            <app-datepicker #d class="position" [scale]="0.9" [range]="false"
              [inputFromDate]="this.deviceForm.get('meterInstallationDate')?.value"
              (dateRangeChanged)="onDateRangeChanged($event)"
              (close)="isDatepickerShown = false"></app-datepicker>
            }
            <div *ngIf="formErrorsExists('meterInstallationDate')" class="validation-error">
              {{ "DEVICESETUP_INSTALLATIONDATE" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
            <div
              *ngIf="deviceForm.get('meterInstallationDate')?.untouched && deviceForm.get('meterInstallationDate')?.invalid"
              class="validation-instruction">
              {{ "DEVICESETUP_INSTALLATIONDATEDESC" | translate }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="meterManufactureDate">{{
              "DEVICESETUP_MANUFACTUREDATE" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div" (click)="toggleManufactureDatepicker(); $event.stopPropagation()">
              <input type="hidden" formControlName="meterManufactureDate" />
              <input id="meterManufactureDate" type="text" [value]="formattedMeterManufactureDate" readonly />
            </div>
            @if (isManufactureDatepickerShown) {
            <app-datepicker #md class="position" [scale]="0.9" [range]="false"
              [inputFromDate]="this.deviceForm.get('meterManufactureDate')?.value"
              (dateRangeChanged)="onManufactureDateChanged($event)"
              (close)="isManufactureDatepickerShown = false"></app-datepicker>
            }
            <div class="clear d-flex justify-content-end" *ngIf="deviceForm.get('meterManufactureDate')?.value" (click)="clearManufactureDate()">
              <span>{{ "CLEAR" | translate }}</span>
            </div>
          </div>
        </div>

        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="security">{{
              "DEVICESETUP_SECURITY" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="security" formControlName="security" type="text" />
            </div>
            <div class="validation-instruction">
              {{ "DEVICESETUP_SECURITYINFODESC" | translate }}
            </div>
          </div>

        </div>
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="blockCipherKey">{{
              "DEVICESETUP_BLOCKCIPHERKEY" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="blockCipherKey" formControlName="blockCipherKey" type="text" />
            </div>
            <div *ngIf="!deviceForm.get('blockCipherKey')?.value" class="validation-instruction">
              {{ "DEVICESETUP_BLOCKCIPHERKEYDESC" | translate }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="authenticationKey">{{
              "DEVICESETUP_AUTHENTICATIONKEY" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="form-input-div">
              <input id="authenticationKey" formControlName="authenticationKey" type="text" />
            </div>
            <div *ngIf="!deviceForm.get('authenticationKey')?.value" class="validation-instruction">
              {{ "DEVICESETUP_AUTHENTICATIONKEYDESC" | translate }}
            </div>
          </div>
        </div>
        <div class="form-item">
          <div class="form-label-div">
            <label class="form-label" for="password">{{
              "DEVICESETUP_PASSWORD" | translate
              }}</label>
          </div>
          <div class="form-input">
            <div class="password-container">
              <input id="password" formControlName="password" [type]="showPassword['password'] ? 'text' : 'password'"
                (keydown.enter)="$event.preventDefault()" />
              <img alt="Password" class="password-icon" [src]="
                  showPassword['password']
                    ? '../../assets/device/password-show.svg'
                    : '../../assets/device/password-hide.svg'
                " (click)="togglePasswordVisibility('password')" />
            </div>
            <div class="validation-instruction">
              {{ "DEVICES_PASSWORDDESC" | translate }}
            </div>
            <div *ngIf="formErrorsExists('password')" class="validation-error">
              {{ "DEVICESETUP_PASSWORD" | translate }} {{ "DEVICESETUP_ISREQUIRED" | translate }}.
            </div>
          </div>
        </div>

        <div class="password-change-section">
          <div class="form-item ms-2">
            <div class="form-label-div">
              <label class="form-label">{{
                "DEVICESETUP_CHANGEPASSWORDONMETER" | translate
                }}</label>
            </div>
            <div class="form-input ps-3">
              <div class="toggle-wrapper">
                <input type="checkbox" [(ngModel)]="changePasswordOnMeter"
                       [ngModelOptions]="{standalone: true}"
                       [disabled]="!!deviceForm.get('password')?.disabled"
                       (change)="onChangePasswordCheckboxToggle()" />
              </div>
              <div class="section-desc">
                {{ "DEVICESETUP_CHANGEPASSWORDONMETER_DESC" | translate }}
              </div>
              <!-- <div *ngIf="passwordChangeBlocked" class="validation-error">
                {{ "DEVICE_PWDCHANGE_PENDING" | translate }}
              </div> -->
            </div>
          </div>

          <ng-container *ngIf="changePasswordOnMeter">
            <div class="form-item">
              <div class="form-label-div">
                <label class="form-label" for="newPassword">{{
                    "DEVICESETUP_NEWPASSWORD" | translate
                  }}</label>
              </div>
              <div class="form-input">
                <div class="password-container">
                  <input id="newPassword" formControlName="newPassword" [type]="showPassword['newPassword'] ? 'text' : 'password'"
                         maxlength="8" (keydown.space)="$event.preventDefault()"
                         (keydown.enter)="$event.preventDefault()" />
                  <img alt="Password" class="password-icon" [src]="
                      showPassword['newPassword']
                        ? '../../assets/device/password-show.svg'
                        : '../../assets/device/password-hide.svg'
                    " (click)="togglePasswordVisibility('newPassword')" />
                </div>
                <div *ngIf="deviceForm.get('newPassword')?.errors?.['pattern']"
                  class="validation-error">
                  {{ "DEVICES_NEWPASSWORDERROR" | translate }}
                </div>
              </div>
            </div>

            <div class="form-item">
              <div class="form-label-div">
                <label class="form-label" for="repeatNewPassword">{{
                    "DEVICESETUP_REPEATNEWPASSWORD" | translate
                  }}</label>
              </div>
              <div class="form-input">
                <div class="password-container">
                  <input id="repeatNewPassword" formControlName="repeatNewPassword"
                         [type]="showPassword['repeatNewPassword'] ? 'text' : 'password'"
                         maxlength="8" (keydown.space)="$event.preventDefault()"
                         (keydown.enter)="$event.preventDefault()" />
                  <img alt="Password" class="password-icon" [src]="
                      showPassword['repeatNewPassword']
                        ? '../../assets/device/password-show.svg'
                        : '../../assets/device/password-hide.svg'
                    " (click)="togglePasswordVisibility('repeatNewPassword')" />
                </div>
                <div *ngIf="newPasswordEntered"
                  [class.validation-instruction]="repeatPasswordState !== 'mismatch'"
                  [class.validation-error]="repeatPasswordState === 'mismatch'"
                  [style.color]="repeatPasswordState === 'match' ? 'green' : null">
                  {{ (repeatPasswordState === 'match'
                        ? 'DEVICES_PASSWORDSMATCH'
                        : repeatPasswordState === 'mismatch'
                          ? 'DEVICES_PASSWORDSNOMATCH'
                          : 'DEVICES_REPEATNEWPASSWORD') | translate }}
                </div>
              </div>
            </div>
          </ng-container>
        </div>

      </div>
      <div class="footer">
        <div class="exit" (click)="toggleModal()">
          {{ "GO_BACK" | translate }}
        </div>
        <div class="add">
          <button type="submit" [disabled]="(deviceForm.invalid && submitted) || submitting || passwordsMismatch">
            {{ "SAVE_CHANGES" | translate }}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
